export var USER_AGENT_CLIENT_HINTS_PLACEHOLDER_BRAND_PREFIX = 'Not';
export var USER_AGENT_DATA_KNOWN_BROWSER_BRANDS = [
    'Microsoft Edge',
    'Opera',
    'Brave',
    'Vivaldi',
    'Samsung Internet',
    'Google Chrome',
    'Firefox',
    'Safari',
    'Chromium'
];
var UserAgent = {
    GOOGLE_BOT: 'GoogleBot'
};
export default UserAgent;
